<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-03-04 09:34:16
!-->
<template>
  <div id="index" class="index">
    <div v-show="isAddPanle" class="mask" @click="() => { isAddPanle = false; }" />
    <div class="shipments-query">
      <el-checkbox-group v-model="orderType" @change="getOrderList()">
        <el-checkbox-button
          v-for="item in ordertypeList"
          :key="item.value"
          :label="item.value"
        >{{ item.name }}</el-checkbox-button>
      </el-checkbox-group>
      <div class="shipments-query-control">
        <div class="query-control-input">
          <el-input
            v-model="listQuery.keywords"
            placeholder="订单号/参考号/快递单号查询"
            style="width: 300px;"
            clearable
          />
          <div class="query-control-date">
            <el-select v-model="listQuery.dateType">
              <el-option label="下单时间" :value="1">下单时间</el-option>
              <el-option label="收货时间" :value="2">收货时间</el-option>
            </el-select>
            <el-date-picker
              v-if="listQuery.dateType==1"
              v-model="createDate"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            />
            <el-date-picker
              v-if="listQuery.dateType==2"
              v-model="receiveDate"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            />
          </div>
          <el-button class="search-class" @click="getOrderList"><i class="el-icon-search" /></el-button>
          </el-input>
        </div>
        <div class="shipments-right">
          <el-button type="primary" plain @click="clickAdd">自定义列</el-button>
          <el-button type="primary" plain @click="exportOrder">导出为CSV</el-button>
          <div v-if="isAddPanle" class="columns-panle">
            <vuedraggable v-model="columeList" class="wrapper" @update="updateSort">
              <template v-for="(item,index) in columeList">
                <div
                  :key="index"
                  :class="['list-item']"
                  style="cursor: pointer;"
                  @click="activeList(item,index)"
                >
                  <div :class="item.isCheck ?'choose-icon-active':'choose-icon'" />
                  <span>{{ item.label }}</span>
                </div>
              </template>
            </vuedraggable>
          </div>
        </div>
      </div>
    </div>

    <el-tabs v-model="selectTab" class="shipments-tabs" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        class="shipments-tabs-pane"
        :label="item.title+'('+item.num +')'"
        :name="index+''"
      >
        <el-table
          ref="ordertable"
          v-loading="tableLoading"
          :data="orderList"
          class="order-table"
          height="520"
          :header-cell-style="{ background: '#F5F6F9', color: '#32343C' }"
        >
          <el-table-column
            v-for="(item,index) in columeList"
            v-if="item.isCheck|| item.fixed || item.type=='action'"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.type == 'action'">
                <el-button
                  v-if="scope.row.status>2"
                  class="text5"
                  type="text"
                  @click="toOrder(scope.row)"
                >详情</el-button>
                <el-button
                  v-if="scope.row.status==1||scope.row.status==2"
                  class="text5"
                  type="text"
                  @click="toOrder(scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.status>1&&scope.row.status<5"
                  class="text5"
                  type="text"
                  @click="printCartonLabel(scope.row)"
                >打印箱唛</el-button>
                <el-button
                  v-if="scope.row.status<3"
                  class="text6"
                  type="text"
                  @click="cancelOrder(scope.row)"
                >取消</el-button>
                <el-button
                  v-if="scope.row.status==2"
                  class="text5"
                  type="text"
                  @click="exportInWarehouseOrder(scope.row)"
                >打印入仓单</el-button>
              </div>
              <div v-else-if="item.prop=='orderNo'">
                <div>
                  <el-link class="text2" @click="toOrder(scope.row)">
                    {{ scope.row.orderNo }}</el-link>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">{{ scope.row.lastTrackTime }}<br>{{ scope.row.lastTrack }}
                    </div>
                    <span v-if="scope.row.lastTrack" class="orderNo-tag">最新轨迹</span>
                  </el-tooltip>
                </div>
                <div class="text1">参考号：{{ scope.row.refNo }}</div>
                <div class="text1">跟踪号：{{ scope.row.finalDeliveryCode }}</div>
              </div>
              <div v-else-if="item.prop=='status'">
                <div class="text3">{{ scope.row.statusNameCn }}</div>
                <div class="text3">{{ scope.row.auditStatus==1?"已审":"未审" }}</div>
              </div>
              <div v-else-if="item.prop=='orderType'">
                <div class="text3">{{ scope.row.businessTypeCn }}</div>
                <div class="text1">{{ scope.row.channelName }}</div>
                <div class="text1">{{ scope.row.modeName }}</div>
              </div>
              <div v-else-if="item.prop=='orderTime'">
                <div>
                  <div class="text1">下单</div>
                  <div class="text4">{{ scope.row.creatorTimeStrCn }}</div>
                </div>
                <div>
                  <div class="text1">收货</div>
                  <div class="text4">{{ scope.row.inStoreTimeStrCn }}</div>
                </div>
              </div>
              <div v-else-if="item.prop=='goodsInfo'">
                <div class="flex" style="align-items: center;">
                  <span v-if="scope.row.inStoreTimeStrCn=='-'" class="goodsinfo-tag1">预</span>
                  <span v-else class="goodsinfo-tag2">收</span>
                  <span>{{ scope.row.totalQuantity }}件|{{ scope.row.totalWeight }}KG|{{ scope.row.totalVolume }}CBM</span>
                </div>
              </div>
              <div v-else-if="item.prop=='city'">
                <div class="table-city">
                  <div style="justify-content: center">
                    <img src="@/assets/img/client/check/DeliveryIcon.png" width="12" height="12">
                    <div class="column-line" />
                    <img src="@/assets/img/client/check/DepartureIcon.png" width="10" height="12">
                  </div>
                  <div style="margin: 0px 10px;">
                    <span class="text1">起运</span>
                    <span style="height: 12px;" />
                    <span class="text1">目的</span>
                  </div>
                  <div>
                    <span
                      v-if="scope.row.businessType==1||scope.row.businessType==3"
                      class="text4"
                    >{{ scope.row.startCityNameEn }},{{ scope.row.startCityNameCn }}</span>
                    <span
                      v-if="scope.row.businessType==2"
                      class="text4"
                    >{{ scope.row.departureCode }}</span>
                    <span
                      v-if="scope.row.businessType==4"
                      class="text4"
                    >{{ scope.row.shipPortCode }}</span>
                    <span style="height: 12px;" />
                    <!-- <span
                      v-if="scope.row.businessType==1"
                      class="text4"
                    >{{ scope.row.destCityNameEn }},{{ scope.row.destCityNameEn }}</span>
                    <span
                      v-if="scope.row.businessType==2"
                      class="text4"
                    >{{ scope.row.destinationCode }}</span>
                    <span
                      v-if="scope.row.businessType==3&&scope.row.storeCode"
                      class="text4"
                    >#{{ scope.row.storeCode }} -
                      {{ scope.row.destCountryNameEn }}</span>
                    <span
                      v-if="scope.row.businessType==3&&!scope.row.storeCode"
                      class="text4"
                    >{{ scope.row.destCityNameEn }} ,
                      {{ scope.row.destProvinceCode }} - {{ scope.row.destCountryNameEn }}</span>
                    <span
                      v-if="scope.row.businessType==4"
                      class="text4"
                    >{{ scope.row.destPortCode }}</span> -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.destCountryNameEn+','+scope.row.destProvinceCode+','+scope.row.destCityNameEn+','+scope.row.destAddress+','+scope.row.destContacts+','+scope.row.destPhone"
                      placement="top-start"
                    >
                      <span
                        class="text4 sub"
                      >{{ scope.row.destCountryNameEn }},{{ scope.row.destProvinceCode }},{{ scope.row.destCityNameEn }},{{ scope.row.destAddress }},{{ scope.row.destContacts }},{{ scope.row.destPhone }}</span>
                    </el-tooltip>

                  </div>
                </div>
              </div>
              <div v-else-if="item.prop=='customsMethod'">
                <div class="text4">{{ scope.row.customsService| dynamicText(customsServiceOptions) }}
                </div>
                <div class="text4">USD {{ scope.row.goodsValue }}</div>
              </div>
              <div v-else-if="item.prop=='isInsurance'">
                <div class="text4">{{ scope.row.isInsurance==1?"是":"否" }}</div>
              </div>
              <div v-else>
                <div class="text4">{{ scope.row[item.prop] }}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total,sizes, prev, pager, next"
          class="order-table-page"
          :total="total"
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange"
        />
      </el-tab-pane>
    </el-tabs>

    <ExpOrder
      v-if="businessType == 1"
      ref="ExpOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
    <AirOrder
      v-if="businessType == 2"
      ref="AirOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
    <FBAOrder
      v-if="businessType == 3"
      ref="FBAOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
    <SeaOrder
      v-if="businessType == 4"
      ref="SeaOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable'
import Table from './Table.vue'
import request from '@/utils/request'
import {
  CancelFBAOrder,
  CancelAirOrder,
  CancelExpOrder,
  CancelSeaOrder
} from '@/api/order.js'

import FBAOrder from '@/client/home/placeAnOrder/fba/confirmOrder.vue'
import ExpOrder from '@/client/home/placeAnOrder/exp/confirmOrder.vue'
import AirOrder from '@/client/home/placeAnOrder/air/confirmOrder.vue'
import SeaOrder from '@/client/home/placeAnOrder/sea/confirmOrder.vue'

import {
  ExportShipment
} from '@/api/user.js'
import {
  getCookie
} from '@/utils/cookiejs'
import {
  getDictionaryDataSelector
} from '@/api/dictionary'
export default {
  name: 'Index',
  components: {
    FBAOrder,
    ExpOrder,
    AirOrder,
    SeaOrder,
    vuedraggable
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      isSearch: false,
      inputStatus: false, // 输入框状态
      searchKey: '', // 搜索关键词
      search_btn: false,
      deleteIcon: false, // 删除按钮
      isAddPanle: false,
      columeList: [{
        prop: 'orderNo',
        width: 230,
        label: '单号',
        isCheck: true,
        fixed: 'left',
        disabled: true
      },
      {
        prop: 'status',
        width: 130,
        label: '订单状态/审核状态',
        isCheck: true,
        disabled: true
      },
      {
        prop: 'orderType',
        minWidth: 200,
        label: '订单类型/下单渠道/派送方式',
        isCheck: true
      },
      {
        prop: 'orderTime',
        width: 150,
        label: '订单时间',
        isCheck: true
      },
      {
        prop: 'goodsInfo',
        width: 200,
        label: '货物信息',
        isCheck: true
      },
      {
        prop: 'city',
        width: 300,
        label: '起运城市/目的城市',
        isCheck: true
      },
      {
        prop: 'customsMethod',
        width: 120,
        label: '报关方式/货值',
        isCheck: true
      },
      {
        prop: 'goodsWarehouseName',
        width: 140,
        label: '交货仓库',
        isCheck: true
      },
      {
        prop: 'goodsReadyTimeStrCn',
        width: 150,
        label: '货好时间',
        isCheck: false
      },
      {
        prop: 'deliveryTime',
        width: 150,
        label: '送达时间',
        isCheck: false
      },
      {
        prop: 'departure',
        width: 200,
        label: '起运港/机场',
        isCheck: false
      },
      {
        prop: 'destination',
        width: 200,
        label: '目的港/机场',
        isCheck: false
      },
      {
        prop: 'carrierName',
        width: 200,
        label: '船公司/承运商',
        isCheck: false
      },
      {
        prop: 'isInsurance',
        width: 80,
        label: '是否投保',
        isCheck: false
      },
      {
        prop: 'vessel',
        width: 180,
        label: '船名/航班',
        isCheck: false
      },
      {
        prop: 'creatorName',
        width: 100,
        label: '下单人',
        isCheck: false
      },
      {
        prop: '',
        width: 150,
        label: '操作',
        type: 'action',
        fixed: 'right',
        isCheck: true,
        hideCheck: true
      }
      ],
      token: '',
      tabList: [{
        title: '全部',
        num: 0
      },
      {
        title: '进行中',
        num: 0
      },
      {
        title: '待确认',
        num: 0
      }
      ],
      businessType: 0,
      selectNumber: 1,
      selectTab: '1',
      ordertypeList: [{
        name: 'FBA',
        value: 3
      },
      {
        name: '快递',
        value: 1
      },
      {
        name: '空运',
        value: 2
      },
      {
        name: '海运散货',
        value: 4
      }
      ],
      cities: ['上海', '北京', '广州', '深圳'],
      tableLoading: false,
      checkListAll: true,
      isIndeterminate: true,
      orderType: [],
      receiveDate: [],
      createDate: [],
      listQuery: {
        businessType: [],
        dateType: 1,

        status: 1,
        keywords: '',
        currentPage: 1,
        pageSize: 10,
        sort: 'desc',
        sidx: ''
      },
      total: 0,
      orderList: [],
      deatilsPath: '/customer/deatils', // 表格当前行跳转路径
      tableList: [{
        id: 0,
        name: 'name',
        label: '姓名',
        type: 'text',
        param: '',
        isShow: true,
        exp: '',
        extra: {
          icon: 'file-list-line'
        }
      },
      {
        id: 0,
        name: 'name',
        label: '姓名',
        type: 'text',
        param: '',
        isShow: true,
        exp: '',
        extra: {
          icon: 'file-list-line'
        }
      }
      ],
      customsServiceOptions: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getOrderList()
      localStorage.setItem('columeList', JSON.stringify(this.columeList))
      this.getCustomsService()
    }
  },
  methods: {
    getCustomsService() {
      // 特殊服务
      getDictionaryDataSelector('CustomsService').then(res => {
        this.customsServiceOptions = res.data.list
      })
    },
    handleTabClick(val) {
      if (val.name == '0') {
        this.listQuery.status = 2
        this.listQuery.currentPage = 1
      } else if (val.name == '1') {
        this.listQuery.status = 1
        this.listQuery.currentPage = 1
      } else if (val.name == '2') {
        this.listQuery.status = 0
        this.listQuery.currentPage = 1
      }
      this.getOrderList()
    },
    onCheckChange() {
      this.$nextTick(() => {
        this.$refs.ordertable[parseInt(this.selectTab)].doLayout()
      })
    },
    onCheckAllChange(val) {
      if (val) this.columeList.forEach((v) => (v.isCheck = true))
      else this.columeList.forEach((v) => (v.isCheck = false))
      this.isIndeterminate = false
      this.$nextTick(() => {
        this.$refs.ordertable[parseInt(this.selectTab)].doLayout()
      })
    },
    exportInWarehouseOrder(row) {
      request({
        url: `api/wms/template/getSceneTemplate/inwarehouse_export_tpl`,
        method: 'GET'
      }).then(res => {
        if (res.code == 200 && res.data.length > 0) {
          var templateId = res.data[0].id
          request({
            url: `/api/wms/warehouse/ExportInWarehouseOrder`,
            method: 'GET',
            headers: {
              'Authorization': this.token
            },
            data: {
              orderNo: row.orderNo,
              templateId: templateId
            }
          }).then((res1) => {
            if (res1.code == 200 && res1.data != null) {
              this.xms.downloadFile(res1.data.url)
            }
          })
        }
      })
    },
    printCartonLabel(row) {
      request({
        url: `/api/webapi/Order/GetMarkUrl`,
        method: 'GET',
        headers: {
          'Authorization': this.token
        },
        data: {
          id: row.orderNo
        }
      }).then((res) => {
        if (res.code == 200 && res.data != null) {
          this.xms.downloadFile(res.data)
        }
      })
    },
    cancelOrder(row) {
      this.$confirm('确定取消该订单吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (row.businessType) {
          case 1:
            this.$nextTick(() => {
              CancelFBAOrder({
                orderNo: row.orderNo
              }).then(res => {
                if (res.code == 200) {

                }
              })
            })
            break
          case 2:
            this.$nextTick(() => {
              this.$refs.AirCancel.init(row)
            })
            break
          case 3:
            this.$nextTick(() => {
              CancelFBAOrder({
                orderNo: row.orderNo
              }).then(res => {
                if (res.code == 200) {
                  this.$message({
                    message: res.msg,
                    type: 'success',
                    duration: 1000,
                    onClose: () => {
                      this.getOrderList()
                    }
                  })
                }
              })
            })
            break
          case 4:
            this.$nextTick(() => {
              this.$refs.SeaCancel.init(row)
            })
            break
        }
      })
    },
    toOrder(row, orderIndex) {
      this.businessType = row.businessType
      switch (row.businessType) {
        case 1:
          this.$nextTick(() => {
            this.$refs.ExpOrder.initOrder(row.orderNo, orderIndex)
          })
          break
        case 2:
          this.$nextTick(() => {
            this.$refs.AirOrder.initOrder(row.orderNo, orderIndex)
          })
          break
        case 3:
          this.$nextTick(() => {
            this.$refs.FBAOrder.initOrder(row.orderNo, orderIndex)
          })
          break
        case 4:
          this.$nextTick(() => {
            this.$refs.SeaOrder.initOrder(row.orderNo, orderIndex)
          })
          break
      }
    },
    pageSizeChange(val) {
      this.listQuery.currentPage = 1
      this.listQuery.pageSize = val
      this.getOrderList()
    },
    pageCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getOrderList()
    },
    updateSort() {
      localStorage.removeItem('columeList')
      localStorage.setItem('columeList', JSON.stringify(this.columeList))
      this.$nextTick(() => {
        this.$refs.Table.updateSort()
      })
    },
    exportOrder() {
      ExportShipment({
        status: this.selectNumber
      }).then((res) => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    getOrderList() {
      if (this.orderType && this.orderType.length > 0) {
        this.listQuery.businessType = this.orderType.join()
      } else {
        this.listQuery.businessType = undefined
      }
      if (this.listQuery.dateType == 1 && this.createDate && this.createDate.length > 0) {
        this.listQuery.startCreatorTime = this.createDate[0]
        this.listQuery.endCreatorTime = this.createDate[1]
      } else {
        this.listQuery.startCreatorTime = undefined
        this.listQuery.endCreatorTime = undefined
      }
      if (this.listQuery.dateType == 2 && this.receiveDate && this.receiveDate.length > 0) {
        this.listQuery.startReceiveTime = this.receiveDate[0]
        this.listQuery.endReceiveTime = this.receiveDate[1]
      } else {
        this.listQuery.startReceiveTime = undefined
        this.listQuery.endReceiveTime = undefined
      }
      this.tableLoading = true
      this.getOrderInfo()
      request({
        url: `/api/shipping/PersonOrder`,
        method: 'GET',
        data: this.listQuery,
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.data != null) {
          this.orderList = res.data.list
          this.total = res.data.pagination.Total
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    clickAdd() {
      this.isAddPanle = true
    },
    changeType(type) {
      this.searchData.type = type
    },
    activeList(item, index) {
      if (!item.disabled) {
        item.isCheck = !item.isCheck
        localStorage.removeItem('columeList')
        localStorage.setItem('columeList', JSON.stringify(this.columeList))
      }
    },
    focusInput() {
      this.inputStatus = true
      // 选中文本
      this.$refs.orderSearchInput.select()
      if (this.searchKey.length > 0) {
        this.deleteIcon = true
      }
    },
    getOrderInfo() {
      request({
        url: `/api/shipping/PersonOrder/GetOrderCounts`,
        method: 'GET',
        data: this.listQuery,
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.data != null) {
          this.tabList[0].num = res.data.total
          this.tabList[1].num = res.data.goingCount
          this.tabList[2].num = res.data.unConfirmCount
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 100;
	}

	.shipments-query {
		width: 100%;
		text-align: left;
		background: #ffffff;
		border-radius: 10px;
		padding: 20px;
		box-sizing: border-box;

		.shipments-query-control {
			display: flex;
			justify-content: space-between;
			margin-top: 15px;

			.query-control-input {
				display: flex;

				.search-class {
					width: 46px;
					height: 32px;
					background: #3370ff;
					border-radius: 8px;
					line-height: 32px;
					color: #ffffff;

					&:hover {
						background: #3370ff;
					}

					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}

				.query-control-date {
					display: flex;
					width: fit-content;
					margin: 0 15px;

					::v-deep .el-input__inner:nth-child(1) {
						width: 120px;
						border-top-right-radius: 0;
						border-bottom-right-radius: 0;
						border-right: none;
					}

					::v-deep .el-input__inner:focus {
						border: 1px solid #DCDFE6;
					}

					::v-deep .el-input__inner:nth-child(2) {
						border-top-left-radius: 0;
						border-bottom-left-radius: 0;
					}
				}
			}
		}

		.shipments-right {
			float: right;
			display: flex;

			.columns-panle {
				width: 280px;
				height: auto;
				background: #ffffff;
				box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
				border-radius: 8px;
				border: 1px solid rgba(221, 221, 221, 0.56);
				position: absolute;
				z-index: 100;
				top: 265px;
				right: 45px;
				padding: 6px 0;

				.list-item {
					height: 33px;
					line-height: 33px;
					background: rgba(255, 255, 255, 0);
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 22px;
					text-align: left;
					display: flex;
					align-items: center;
					padding-right: 12px;

					&:hover {
						background: #f2f4f8;

						.img_icon {
							background: url('../../assets/img/manage/settings/a_1.jpg');
							width: 16px;
							height: 16px;
							background-size: 16px 16px;
							margin-left: auto;
						}
					}

					.img_icon {
						&:active {
							background: url('../../assets/img/manage/settings/a_2.jpg');
							width: 16px;
							height: 16px;
							background-size: 16px 16px;
							margin-left: auto;
						}
					}

					.img_icon {
						background: url('../../assets/img/manage/settings/a_1.jpg');
						width: 16px;
						height: 16px;
						background-size: 16px 16px;
						margin-left: auto;
					}

					.choose-icon {
						width: 16px;
						height: 16px;
						background: #ffffff;
						border-radius: 4px;
						border: 1px solid #cccccc;
						margin: 16px 8px 16px 16px;
						box-sizing: border-box;
					}

					.choose-icon-active {
						background: url('../../assets/img/client/check/icon_ic_xp_selected@2x.png');
						background-size: 16px 16px;
						width: 16px;
						height: 16px;
						margin: 16px 8px 16px 16px;
					}
				}
			}

			// div {
			// 	cursor: pointer;
			// 	height: 32px;
			// 	line-height: 32px !important;
			// 	background: rgba(233, 85, 6, 0);
			// 	border-radius: 4px;
			// 	border: 1px solid #3370ff;
			// 	font-family: PingFangSC, PingFang SC;
			// 	font-weight: 500;
			// 	font-size: 14px;
			// 	color: #3370FF;
			// 	line-height: 20px;
			// 	text-align: center;
			// }

			// .add-active {
			// 	background: rgba(233, 85, 6, 0);
			// }

			// div:nth-of-type(1) {
			// 	width: 112px;
			// 	margin-right: 16px;
			// }

			// div:nth-of-type(2) {
			// 	width: 112px;
			// }
		}

	}

	.shipments-tabs {
		background: #ffffff;
		margin-top: 10px;
		border-radius: 10px;
		padding: 10px;

		::v-deep .el-tabs__item {
			width: 100px;
			padding: 0;
			text-align: center;
		}

		.shipments-tabs-pane {
			.order-table {
				max-height: 530px;
				overflow: auto;

				::v-deep .has-gutter {
					background: #F5F6F9;
				}

				button {
					margin-left: 10px;
				}
			}

			.order-table-page {
				margin-top: 10px;
				text-align: right;
			}

			.orderNo-tag {
				border: 1px solid #DCDEE0;
				font-size: 12px;
				padding: 2px 4px;
				border-radius: 4px;
				margin-left: 5px;
			}

			.goodsinfo-tag1 {
				width: 12px;
				height: 12px;
				line-height: 12px;
				text-align: center;
				border: 1px solid #56BB24;
				border-radius: 50%;
				font-size: 12px;
				background: #F1FFEA;
				color: #56BB24;
				padding: 2px;
				margin-right: 8px;
			}

			.goodsinfo-tag2 {
				width: 12px;
				height: 12px;
				line-height: 12px;
				text-align: center;
				border: 1px solid #3370FF;
				border-radius: 50%;
				font-size: 12px;
				background: #F7F9FF;
				color: #3370FF;
				padding: 2px;
				margin-right: 8px;
			}

			.table-city {
				display: flex;

				.column-line {
					height: 25px;
					width: 2px;
					background-image: linear-gradient(to bottom, #E1E1E1 50%, transparent 50%);
					background-size: 1px 4px;
					background-repeat: repeat-y;
				}

				div {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;
				}
			}

			.text1 {
				font-size: 12px;
				color: #aaaaaa;
			}

			.text2 {
				font-size: 14px;
				color: #3370FF;
			}

			.text3 {
				font-size: 14px;
				color: #313235;
			}

			.text4 {
				font-size: 14px;
				color: #313235;
			}

			.sub{
				overflow: hidden;          /* 隐藏溢出内容 */
				  white-space: nowrap;      /* 禁止文本换行 */
				  text-overflow: ellipsis;  /* 超出部分显示省略号 */
				  width: 220px;              /* 必须设置固定宽度 */
			}

			.text5 {
				font-size: 14px;
				color: #3370FF;
			}

			.text6 {
				font-size: 14px;
				color: #FF3333;
			}

		}
	}

	.shipments {
		display: flex;
		justify-content: space-between;

		.shipments-tab {
			display: flex;
			justify-content: start;

			.Company-Details,
			.Users {
				padding: 0 8px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #777777;
				line-height: 22px;
				text-align: center;
				font-style: normal;
				margin-right: 16px;
				line-height: 32px;
				background: rgba(255, 255, 255, 0.56);
				border-radius: 6px;
				cursor: pointer;
			}

			.active {
				max-width: 170px;
				min-width: 59px;
				height: 32px;
				line-height: 32px;
				background: #ffffff;
				border-radius: 6px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 16px;
				color: #3370ff;
				text-align: center;
				font-style: normal;
				padding: 0 8px;
			}

			.search-class {
				width: 32px;
				height: 32px;
				background: #3370ff;
				border-radius: 8px;
				line-height: 32px;
				color: #ffffff;

				&:hover {
					background: #3370ff;
				}

				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}

			.order-search {
				display: flex;
				align-items: center;
				width: 240px;
				height: 32px;
				padding: 0 3px 0 12px;
				background: #ffffff;
				border-radius: 6px;
				border: 1px solid #3370ff;
				position: relative;
				box-sizing: border-box;
				transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

				&:hover {
					background: #ffffff;
					transition: all 0.2s;

					.order-search-input .order-search-input__inner {
						background: #ffffff;
						transition: all 0.2s;
					}
				}

				.order-search-input {
					position: relative;

					.order-search-input__inner {
						width: 170px;
						height: 18px;
						padding: 6px 0;
						font-size: 13px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 18px;
						outline: none;
						border: none;

						&::-webkit-input-placeholder {
							font-size: 13px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #aaaaaa;
							line-height: 18px;
						}
					}

					.delete-icon {
						position: absolute;
						width: 20px;
						height: 16px;
						top: 8px;
						right: -20px;
						cursor: pointer;
						z-index: 9999;
						display: flex;
						align-items: center;
					}
				}

				.order-search-btn {
					position: absolute;
					right: 0px;
					width: 32px;
					height: 32px;
					background: #3370ff;
					border-radius: 8px;
					line-height: 32px;
					color: #ffffff;

					&:hover {
						background: #3370ff;
					}

					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			}
		}

		.shipments-right-main {
			position: relative;

			.shipments-right {
				float: right;
				display: flex;

				div {
					cursor: pointer;
					height: 32px;
					line-height: 32px !important;
					background: rgba(233, 85, 6, 0);
					border-radius: 8px;
					border: 1px solid #3370ff;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #3370FF;
					line-height: 20px;
					text-align: center;
				}

				.add-active {
					background: rgba(233, 85, 6, 0);
				}

				div:nth-of-type(1) {
					width: 112px;
					margin-right: 16px;
				}

				div:nth-of-type(2) {
					width: 112px;
				}
			}

		}
	}

	.table-main {
		background: #ffffff;
		border-radius: 8px;
		padding: 24px;
		margin-top: 16px;
	}
</style>
